import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { LoaderPortal } from 'AppSrc/core/components/portals/loader-portal';
import { ClockLoadingSvg } from 'AppSrc/core/components/common/svg-icons';
import { LoadingBar } from './sub-components/loading-bar';
import 'AppSrc/core/style/components/utility/loader.css';


const getProportionComplete = (arr) => {
  // if the item in the array is truthy, adds it to the percentage
  const totalComplete = arr.reduce((currentValue, item) => (item ? currentValue + 1 : currentValue), 0);

  const meanComplete = totalComplete / arr.length;
  return meanComplete;
};

class Loader extends PureComponent {

  render() {
    const {
      loaderArray,
      loaderTitle,
      loaderText,
    } = this.props;

    const proportionComplete = getProportionComplete(loaderArray);

    return (
      <LoaderPortal>
        <div
          className="loader-section"
        >
          <div className="loader-shadow" />
          <div className="loader-inner">
            <div className="loader-svg-wrapper">
              <div className="svg-container">
                <ClockLoadingSvg />
              </div>
            </div>
            <h2 className="loader-title">
              {loaderTitle}
            </h2>
            <p className="loader-message">
              {loaderText}
            </p>
            <LoadingBar
              proportion={proportionComplete}
            />
          </div>
        </div>
      </LoaderPortal>
    );
  }
}

Loader.propTypes = {
  // FN: I designed this to use truthy as opposed to bools but it may end up just being bools.
  // If you get an invalid props warning, change PropTypes.bool to PropTypes.any
  loaderArray: PropTypes.arrayOf(PropTypes.bool),
  loaderTitle: PropTypes.string,
  loaderText: PropTypes.string,
};

export {
  Loader,
  getProportionComplete,
};



